// extracted by mini-css-extract-plugin
export default {"navbarMenu":"Navbar_navbarMenu__WgVH2","router":"Navbar_router__IfygX","NavBtn":"Navbar_NavBtn__tPyrf","active":"Navbar_active__BNocg"};